<div class="custom-floating-filter" [formGroup]="$any(form)">
    <select class="radio" (change)="selectRadioOption($event)" formControlName="select">
        <option></option>
        @for (option of options; track option) {
            <option value="{{ option.value }}">
                <span>{{ option.label ?? option.value.toString() | translate }}</span>
            </option>
        }
    </select>
</div>
